/* eslint-disable react/display-name */
import "./Switch.scss";
import cx from "classnames";
import { forwardRef, useCallback } from "react";

const Switch = forwardRef(({ value, onChange, status, disabled, ...props }, ref) => {
  const handleSwitch = useCallback(() => {
    if (disabled || !onChange) return;
    onChange(!value);
  }, [disabled, onChange, value]);
  return (
    <div
      {...props}
      ref={ref}
      className={cx("Switch", { isSelectedSlider: value, isDisabled: disabled }, status)}
      onClick={handleSwitch}
    >
      <div className="slider"></div>
    </div>
  );
});

export default Switch;
